"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QueryCache = exports.QueryCache = function QueryCache() {
    _classCallCheck(this, QueryCache);
};


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/QueryCache.js
// module id = 1421
// module chunks = 118